"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortOptions = void 0;
var SortOptions;
(function (SortOptions) {
    SortOptions["DESC"] = "DESC";
    SortOptions["ASC"] = "ASC";
})(SortOptions || (exports.SortOptions = SortOptions = {}));
